import { Component } from '@angular/core';

@Component({
  selector: 'app-page-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyPageComponent {}
